import React from 'react';
import { Search, ArrowUpDown, Filter } from 'lucide-react';

const QuotationFilters = ({
                              searchTerm,
                              onSearchChange,
                              sortBy,
                              onSortByChange,
                              sortOrder,
                              onSortOrderChange
                          }) => {
    const sortOptions = [
        { value: 'createdAt', label: 'Date Created' },
        { value: 'clientName', label: 'Client Name' },
        { value: 'totalAmount', label: 'Amount' },
        { value: 'status', label: 'Status' },
        { value: 'quotationNumber', label: 'Quotation Number' }
    ];

    return (
        <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            marginBottom: '24px'
        }}>
            <div style={{
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
                flexWrap: 'wrap'
            }}>
                {/* Search Input */}
                <div style={{
                    position: 'relative',
                    flex: '1',
                    minWidth: '300px'
                }}>
                    <Search
                        size={20}
                        style={{
                            position: 'absolute',
                            left: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#9ca3af'
                        }}
                    />
                    <input
                        type="text"
                        placeholder="Search quotations, clients, or projects..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '12px 12px 12px 44px',
                            border: '1px solid #d1d5db',
                            borderRadius: '8px',
                            fontSize: '14px',
                            outline: 'none',
                            transition: 'all 0.2s ease'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#1e40af';
                            e.target.style.boxShadow = '0 0 0 3px rgba(30, 64, 175, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#d1d5db';
                            e.target.style.boxShadow = 'none';
                        }}
                    />
                </div>

                {/* Sort By Dropdown */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <label style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#374151',
                        whiteSpace: 'nowrap'
                    }}>
                        Sort by:
                    </label>
                    <select
                        value={sortBy}
                        onChange={(e) => onSortByChange(e.target.value)}
                        style={{
                            padding: '8px 12px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '14px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            outline: 'none'
                        }}
                    >
                        {sortOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Sort Order Toggle */}
                <button
                    onClick={() => onSortOrderChange(sortOrder === 'asc' ? 'desc' : 'asc')}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 12px',
                        backgroundColor: sortOrder === 'desc' ? '#1e40af' : 'white',
                        color: sortOrder === 'desc' ? 'white' : '#374151',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                        if (sortOrder === 'asc') {
                            e.target.style.backgroundColor = '#f9fafb';
                        }
                    }}
                    onMouseOut={(e) => {
                        if (sortOrder === 'asc') {
                            e.target.style.backgroundColor = 'white';
                        }
                    }}
                >
                    <ArrowUpDown size={16} />
                    {sortOrder === 'asc' ? 'Ascending' : 'Descending'}
                </button>

                {/* Advanced Filters Button */}
                <button
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 12px',
                        backgroundColor: 'white',
                        color: '#374151',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                        e.target.style.backgroundColor = '#f9fafb';
                    }}
                    onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'white';
                    }}
                >
                    <Filter size={16} />
                    Advanced Filters
                </button>
            </div>
        </div>
    );
};

export default QuotationFilters;